import { RiErrorWarningLine } from 'react-icons/ri';
import { useField } from 'formik';
import ModalInfo from './modalInfo';

export default function FormInput({
  label,
  name,
  type = 'text',
  required = true,
  ...props
}) {
  const [field, meta] = useField(name);
  const error = meta.touched && meta.error ? meta.error : null;

  return (
    <label className="relative w-full">
      <div className="flex items-center justify-between">
        <p>{label}</p>
        {required && (
          <ModalInfo
            icon={<RiErrorWarningLine />}
            content="Campo Obrigatório!"
          />
        )}
      </div>

      <input
        className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${
          error ? 'border-red-500' : 'border-gray-300'
        }`}
        {...field}
        {...props}
        type={type}
        name={name}
      />

      {error && (
        <p className="text-red-500 text-xs font-medium mt-1">
          {error}
        </p>
      )}
    </label>
  );
}